import React from 'react';
import { compose, withProps } from 'recompose';
import { getNestedValue } from '@/se/utilities/data/object';
import { withRouter } from 'react-router';
import ScreenRouter from './kiosk/ScreenRouter';
import { withSession } from '@/state/Session';
import queryString from 'query-string';
import ConnectionProvider from './kiosk/ConnectionProvider';
import { UnauthorizedScreen } from '@/components/pages/kiosk/UnauthorizedScreen';
import { mapUnauthorizedError } from '@/essentials/mapUnauthorizedError';

const Inject = ({ accessToken, isSuperAdmin, organizationId }) => {
  const queryParams = queryString.parse(location.search);
  const [unauthorized, setUnauthorized] = React.useState(null);
  const handleUnauthorized = error => setUnauthorized(mapUnauthorizedError(error));

  if (unauthorized) {
    return <UnauthorizedScreen description={unauthorized} />;
  }

  if (queryParams.token) {
    return (
      <ConnectionProvider
        accessToken={queryParams.token}
        organizationId={organizationId}
        isHuman={true}
        isSuperAdmin={isSuperAdmin}
        onUnauthorized={handleUnauthorized}
      >
        <ScreenRouter
          accessToken={queryParams.token}
          organizationId={organizationId}
          isHuman={true}
          isSuperAdmin={isSuperAdmin}
          inject
        />
      </ConnectionProvider>
    );
  }

  return (
    <ScreenRouter
      accessToken={accessToken}
      organizationId={organizationId}
      isHuman={true}
      isSuperAdmin={isSuperAdmin}
      inject
    />
  );
};

export default compose(
  withRouter,
  withProps(({ match }) => ({ organizationId: getNestedValue('params.organizationId', match) })),
  withSession(({ session }) => ({
    accessToken: getNestedValue('token', session),
  }))
)(Inject);
